export type ReviewDataTab = "technical" | "hospitality";

const PROCESSING_STATUSES = new Set(["pending", "processing", "extracting"]);

export type PipelineConfidence = {
  _hospitality_pipeline_step?: unknown;
  _reextraction_step?: unknown;
} | null | undefined;

function nonEmptyStep(value: unknown): string | null {
  return typeof value === "string" && value.trim().length > 0
    ? value
    : null;
}

export function riderExtractionStep(
  confidence: PipelineConfidence,
  explicitStep?: string | null,
): string | undefined {
  return (
    nonEmptyStep(explicitStep) ??
    nonEmptyStep(confidence?._reextraction_step) ??
    nonEmptyStep(confidence?._hospitality_pipeline_step) ??
    undefined
  );
}

export function isRiderProcessing(
  status: string | null | undefined,
  confidence?: PipelineConfidence,
  extractionStep?: string | null,
): boolean {
  return (
    (status != null && PROCESSING_STATUSES.has(status)) ||
    (status === "extracted" &&
      riderExtractionStep(confidence, extractionStep) !== undefined)
  );
}

export function riderLifecycleStatus(
  status: string,
  confidence?: PipelineConfidence,
  extractionStep?: string | null,
): string {
  return isRiderProcessing(status, confidence, extractionStep)
    ? "processing"
    : status;
}

export function isRiderReviewable(
  status: string | null | undefined,
  confidence?: PipelineConfidence,
  extractionStep?: string | null,
): boolean {
  return (
    (status === "extracted" || status === "approved") &&
    !isRiderProcessing(status, confidence, extractionStep)
  );
}

export function matchesRiderStatusFilter(
  status: string,
  confidence: PipelineConfidence,
  filter: string,
  extractionStep?: string | null,
): boolean {
  if (!filter) return true;
  if (filter === "processing" || filter === "extracting") {
    return isRiderProcessing(status, confidence, extractionStep);
  }
  if (filter === "extracted") {
    return (
      status === "extracted" &&
      !isRiderProcessing(status, confidence, extractionStep)
    );
  }
  return status === filter;
}

export function canApproveRider(
  status: string | null | undefined,
  confidence?: PipelineConfidence,
  extractionStep?: string | null,
): boolean {
  return (
    status === "extracted" &&
    !isRiderProcessing(status, confidence, extractionStep)
  );
}

export function availableReviewTab(
  requested: ReviewDataTab,
  hasHospitality: boolean,
): ReviewDataTab {
  return requested === "hospitality" && !hasHospitality
    ? "technical"
    : requested;
}
